import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Tooltip } from 'react-bootstrap';
import $ from 'jquery';
/* Function */
import ObjGeneral from '../function/';
/* Local store */
import { localStoreFN } from '../../store/localStorage';
/* Actions */
import * as summaryInspectionsActions from '../../actions/summary_inspections/index';

/* Components */
import Header from '../../components/summary_inspections/header';
import Table from '../../components/summary_inspections/table';
import Buttons from '../../components/summary_inspections/buttons';
import TitleMain from '../../components/summary_inspections/title';
import Modal from '../../components/common/inspections/modal';
import Loading from '../../components/common/loading';
import Message from '../../components/common/message';
import Expired from '../expired/index';

class SummaryInspections extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pag: 1,
      modalRight: false,
      select: '',
      paramInspection: props.match.params.id_inspection,
      sort: {
        creationDate: null,
        mobileDate: null,
        score: null,
        fails: null
      },
      filter: {
        selectType: null,
        selectInspector: null,
        selectDriver: null,
        selectVehicle: null,
        selectForm: null,
        selectFails: null,
        question1: null,
        question2: null,
        question3: null
      },
      filterName: {
        selectType: null,
        selectInspector: null,
        selectDriver: null,
        selectVehicle: null,
        selectForm: null,
        selectFails: null,
        question1: null,
        question2: null,
        question3: null
      },
      input: {
        selectType: '',
        selectInspector: '',
        selectDriver: '',
        selectVehicle: '',
        selectForm: '',
        selectFails: '',
        question1: '',
        question2: '',
        question3: ''
      }
    };
  }

  async componentDidMount() {
    // get the permissions to validate the view
    const permits = localStoreFN().getItem('permits');
    const permit = permits.includes('form');
    if (permit) {
      if (this.props.setting) {
        // get the setting objects
        const obj = JSON.parse(this.props.setting.value);
        if (obj.generalSetting.views.includes('form')) {
          // we bring the persisted data
          const dateStart = this.props.filters.date.fechaStartFinal || null;
          const dateEnd = this.props.filters.date.fechaEndFinal || null;
          const tags = this.props.filters.tags;
          const mainPers = this.props.filters.main || '1';

          // eslint-disable-next-line react/no-did-mount-set-state
          this.setState({ select: mainPers });
          $('body').click(event => {
            if (!event.target.dataset.fix) {
              if (!event.target.classList.contains('leaflet-container')) {
                $('[data-row]').each(function(item) {
                  document.querySelector('[data-row]').classList.remove('active');
                });

                event.target.classList.add('active');
                this.setState({ modalRight: false });
              }
            }
          });

          // call to Form's fetch api
          await this.props.actions.fetchSummaryInspectionsApi({
            dateStart,
            dateEnd,
            tags,
            filter: this.state.filter,
            pag: this.state.pag,
            main: mainPers
          });
          // COUNT fetch api call
          await this.props.actions.fetchSummaryInspectionsCountApi({
            dateStart,
            dateEnd,
            tags,
            filter: this.state.filter,
            pag: this.state.pag,
            main: mainPers
          });
          await this.props.actions.fetchSummaryInspectionsFilterApi({});
        } else {
          // not authorized
          this.props.history.push('/dashboard/authorization');
        }
      }
    } else {
      // not authorized
      this.props.history.push('/dashboard/authorization');
    }
  }

  // we load the reset function, return the states to their initial state
  componentWillUnmount() {
    $('body').unbind('click');
    this.props.actions.resetSummaryInspections();
  }

  // function performed to sort the table
  handleSort = async event => {
    /* Change sort */
    const sort = { ...this.state.sort };
    if (event.currentTarget.dataset.type === 'creationDate') {
      sort.mobileDate = null;
      sort.score = null;
      sort.fails = null;
    } else if (event.currentTarget.dataset.type === 'mobileDate') {
      sort.creationDate = null;
      sort.score = null;
      sort.fails = null;
    } else if (event.currentTarget.dataset.type === 'score') {
      sort.creationDate = null;
      sort.mobileDate = null;
      sort.fails = null;
    } else if (event.currentTarget.dataset.type === 'fails') {
      sort.creationDate = null;
      sort.mobileDate = null;
      sort.score = null;
    }
    const value = this.state.sort[event.currentTarget.dataset.type] == 'ASC' ? 'DESC' : 'ASC';
    sort[event.currentTarget.dataset.type] = value;
    /* Get Date */
    const objDate = JSON.parse(this.props.setting.value);
    const format = this.props.language.account.date.format;
    const date = ObjGeneral.getDate({ id: null }, format);
    /* Set sort */
    this.setState({
      sort
    });
    /* TAGS */
    const tags = ObjGeneral.getTags({});
    /* Set Pag */
    this.setState({ pag: 1 });
    /* Fetch */
    await this.props.actions.fetchSummaryInspectionsNoLoadingApi({
      sort,
      pag: 1,
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      filter: this.state.filter,
      tags,
      main: this.state.select
    });
  };

  componentDidUpdate() {
    if (
      this.props.status === 200 &&
      this.props.statusTags === 200 &&
      this.props.statusFilter === 200 &&
      this.state.paramInspection
    ) {
      this.handleModalRight(this.state.paramInspection, 'reload', null);
    }
  }

  // functions in charge of displaying the modal
  handleModalRight = async (id, reload, select) => {
    let value;
    this.state.paramInspection = null;

    if (this.state.modalRight !== false && reload !== 'reload') {
      value = false;
      this.props.actions.resetModal({});
      this.setState({ modalRight: value });
      $('[data-row]').each(function(item) {
        document.querySelector(`[data-select="sl${item}"]`).classList.remove('active');
      });
    } else {
      value = true;
      /* TAGS */
      const tags = ObjGeneral.getTags({});
      /* Get Date */
      const objDate = JSON.parse(this.props.setting.value);
      const format = this.props.language.account.date.format;
      const date = ObjGeneral.getDate({ id: null }, format);
      $('[data-row]').each(function(item) {
        document.querySelector(`[data-select="sl${item}"]`).classList.remove('active');
      });
      if (select != null) {
        document.querySelector(`[data-select=${select}]`).classList.add('active');
      }
      this.setState({ modalRight: value });

      await this.props.actions.fetchSummaryInspectionsModalApi({
        id,
        tags,
        dateStart: date.fechaStartFinal,
        dateEnd: date.fechaEndFinal
      });
      await this.props.actions.fetchSummaryInspectionsModalImgApi({
        id
      });
    }
  };

  // function in charge of filtering
  handleFilter = async event => {
    const select = event.target.dataset.select;
    const name = event.target.dataset.name;
    const parent = event.target.dataset.parent;
    const special = event.target.dataset.special;

    if (special) {
      document.getElementById(parent).innerHTML = `<span>${special}:</span><div>${event.target.innerHTML}</div>`;
    } else {
      document.getElementById(parent).innerHTML = `<span>${
        this.props.language.summary.filter[event.target.dataset.parent]
      }:</span><div>${event.target.innerHTML}</div>`;
    }

    const filter = Object.assign({}, this.state.filter);

    filter[event.target.dataset.parent] = select;

    /* Set sort */
    this.setState({
      filter
    });

    const fil = Object.assign({}, this.state.filterName);
    fil[parent] = name;

    this.setState({
      filterName: fil
    });

    /* Get Date */
    const objDate = JSON.parse(this.props.setting.value);
    const format = this.props.language.account.date.format;
    const date = ObjGeneral.getDate({}, format);

    /* TAGS */
    const tags = ObjGeneral.getTags({});

    /* Set Pag */
    this.setState({ pag: 1 });

    /* Fetch */
    await this.props.actions.fetchSummaryInspectionsNoLoadingApi({
      filter,
      pag: 1,
      tags,
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      sort: this.state.sort,
      main: this.state.select
    });

    /* Fetch Count */
    await this.props.actions.fetchSummaryInspectionsCountApi({
      filter,
      tags,
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      main: this.state.select
    });
  };

  // function in charge of filtering by date and tags
  handleSubmit = async obj => {
    /* Get Select */
    const group = document.getElementById('group').value;
    this.setState({ select: group });

    /* Get Date */
    const objDate = JSON.parse(this.props.setting.value);
    const format = this.props.language.account.date.format;
    const date = ObjGeneral.getDate(obj, format);

    /* Set Pag */
    this.setState({ pag: 1 });

    /* TAGS */
    const tags = ObjGeneral.getTags(obj);

    // set filter to persist
    this.props.actions.setFilterSummaryInspections({
      date,
      tags,
      main: group
    });
    /* Fetch */
    await this.props.actions.fetchSummaryInspectionsApi({
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      filter: this.state.filter,
      tags,
      pag: 1,
      sort: this.state.sort,
      main: group
    });

    /* Fetch Count */
    await this.props.actions.fetchSummaryInspectionsCountApi({
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      filter: this.state.filter,
      tags,
      main: group
    });
  };

  // function performed to paginate
  handleScroll = async event => {
    if (this.state.pag < this.props.count.pages) {
      const scroll = event.target.scrollTop;
      const max = event.target.scrollHeight - event.target.offsetHeight;
      if (scroll >= max) {
        /* Change Pag */
        this.setState({ pag: this.state.pag + 1 });
        const pag = this.state.pag + 1;
        /* Get Date */
        const objDate = JSON.parse(this.props.setting.value);
        const format = this.props.language.account.date.format;
        const date = ObjGeneral.getDate({ id: null }, format);

        /* TAGS */
        const tags = ObjGeneral.getTags({});

        /* Fetch */
        await this.props.actions.fetchSummaryInspectionsNoLoadingApi({
          filter: this.state.filter,
          concat: true,
          pag,
          tags,
          dateStart: date.fechaStartFinal,
          dateEnd: date.fechaEndFinal,
          sort: this.state.sort,
          main: this.state.select
        });
      }
    }
  };

  handleChange = e => {
    let input = { ...this.state.input };
    input[e.target.dataset.update] = e.target.value;
    this.setState({
      input
    });
  };

  handleChangeReset = () => {
    this.setState({
      input: {
        selectType: '',
        selectInspector: '',
        selectDriver: '',
        selectVehicle: '',
        selectForm: '',
        selectFails: '',
        question1: '',
        question2: '',
        question3: ''
      }
    });
  };

  handleDownload = async e => {
    /* Get Date */
    const objDate = JSON.parse(this.props.setting.value);
    const format = this.props.language.account.date.format;
    const date = ObjGeneral.getDate({}, format);

    await this.props.actions.fetchDownloadApi({
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      main: this.state.select
    });
  };

  render() {
    // the setting object is obtained which we use for the configuration
    const lang = localStoreFN().getItem('lang');
    const obj = JSON.parse(this.props.setting.value);
    // function that configures the settings according to those defined in the view
    const setting = ObjGeneral.getSetting({
      setting: obj.summaryInspections,
      filter: this.props.filter,
      general: obj.generalSetting
    });
    const tableDate = obj.form.tableDate;
    // condition done to see if the setting was done
    if (this.props.setting) {
      const header = (
        <Header
          main={this.state.select}
          handleSubmit={this.handleSubmit}
          language={this.props.language}
          filter={setting.filter}
          date={this.props.dateMax[3]}
          filters={this.props.filters}
        />
      );
      let container = '';
      // condition performed for loading state of the view
      if (this.props.loading || this.props.loadingFilter) {
        container = <Loading language={this.props.language} />;
        // the 401 status of the application Expired token or unauthorized
      } else if (
        this.props.status === 401 ||
        this.props.statusTags === 401 ||
        this.props.statusFilter === 401
      ) {
        container = <Expired history={this.props.history} />;
        // the status 200 of the application success
      } else if (
        this.props.status === 200 &&
        this.props.statusTags === 200 &&
        this.props.statusFilter === 200
      ) {
        container = (
          <div className="main-container scroll summary-inspections">
            <TitleMain language={this.props.language} />
            <Buttons
              languageFormat={lang}
              filterQuestion={obj.form.filterQuestion}
              handleDownload={this.handleDownload}
              handleChangeReset={this.handleChangeReset}
              handleChange={this.handleChange}
              handleFilter={this.handleFilter}
              language={this.props.language}
              datosFilter={this.props.datosFilter}
              input={this.state.input}
              filter={this.state.filterName}
            />
            <Table
              tableDate={tableDate}
              languageFormat={lang}
              main={this.state.select}
              pag={this.state.pag}
              loadingTable={this.props.loadingTable}
              count={this.props.count}
              language={this.props.language}
              severityFailsColor={obj.form.severityFailsColor}
              filterQuestion={obj.form.filterQuestion}
              handleModal={this.handleModalRight}
              datos={this.props.datos}
              handleSort={this.handleSort}
            />
            <Modal
              languageFormat={lang}
              loading={this.props.loadingModal}
              status={this.props.statusModal}
              datos={this.props.datosModal.main}
              loadingImg={this.props.loadingModalImg}
              statusImg={this.props.statusModalImg}
              datosImg={this.props.datosModalImg}
              main={this.state.select}
              severityFailsColor={obj.form.severityFailsColor}
              question={this.props.datosModal.question}
              handleModal={this.handleModalRight}
              modalRight={this.state.modalRight}
            />
            <Tooltip placement="top" id="pageTooltip" />
          </div>
        );
        // the 500 status of the application
      } else if (
        this.props.status === 500 ||
        this.props.statusTags === 500 ||
        this.props.statusFilter === 500
      ) {
        container = <Message message={this.props.language.error.apiError500} />;
      } else {
        container = <Message message={this.props.language.error.apiError} />;
      }
      return (
        <section className="main" onScroll={this.handleScroll}>
          {header}
          {container}
        </section>
      );
    }
    // in case the setting is not loaded
    return (
      <section className="main">
        <Message message="NO Setting" />
      </section>
    );
  }
}
const mapStateToProps = state => ({
  filter: state.reducer.tags.filter,
  statusTags: state.reducer.tags.status,

  dateMax: state.reducer.dashboard.dateMax,

  setting: state.reducer.dashboard.setting,
  datos: state.reducer.summaryInspections.datos,
  datosFilter: state.reducer.summaryInspections.datosFilter,
  datosModal: state.reducer.summaryInspections.datosModal,
  datosModalImg: state.reducer.summaryInspections.datosModalImg,
  loading: state.reducer.summaryInspections.loading,
  loadingFilter: state.reducer.summaryInspections.loadingFilter,
  loadingModal: state.reducer.summaryInspections.loadingModal,
  loadingModalImg: state.reducer.summaryInspections.loadingModalImg,
  status: state.reducer.summaryInspections.status,
  statusFilter: state.reducer.summaryInspections.statusFilter,
  statusModal: state.reducer.summaryInspections.statusModal,
  statusModalImg: state.reducer.summaryInspections.statusModalImg,
  filters: state.reducer.summaryInspections.filters,
  loadingTable: state.reducer.summaryInspections.loadingTable,
  count: state.reducer.summaryInspections.count,

  language: state.reducer.dashboard.language
});
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(summaryInspectionsActions, dispatch)
});
SummaryInspections.propTypes = {
  count: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  loading: PropTypes.bool.isRequired,
  loadingFilter: PropTypes.bool.isRequired,
  loadingModal: PropTypes.bool.isRequired,
  loadingModalImg: PropTypes.bool.isRequired,
  loadingTable: PropTypes.bool.isRequired,
  datos: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]).isRequired,
  datosFilter: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object])
    .isRequired,
  datosModal: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object])
    .isRequired,
  datosModalImg: PropTypes.oneOfType([PropTypes.array, PropTypes.number, PropTypes.object])
    .isRequired,
  filter: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]).isRequired,
  setting: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
    PropTypes.array
  ]).isRequired,
  status: PropTypes.number,
  statusFilter: PropTypes.number,
  statusModal: PropTypes.number,
  statusModalImg: PropTypes.number,
  statusTags: PropTypes.number,
  actions: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  history: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  language: PropTypes.oneOfType([PropTypes.object]).isRequired,
  dateMax: PropTypes.oneOfType([PropTypes.array]).isRequired,
  filters: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired
};

SummaryInspections.defaultProps = {
  status: null,
  statusFilter: null,
  statusModal: null,
  statusModalImg: null,
  statusTags: null
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SummaryInspections);



// WEBPACK FOOTER //
// ./source/client/containers/summary_inspections/index.jsx